import { createContext, useContext } from "react";

// ---------------------------------------------------------------------------
// Ported from Fluid Functionalism's surface-context (registry:lib).
//
// The surface level the children sit on, on an 8-step ladder (1 is the page).
// Raised components (menus, popovers, dialogs) read it and pick their own
// level relative to it instead of hard-coding one, then provide their new
// level to what they contain. A menu that hard-codes its background ends up
// the same color as the dialog it opens in and melts into it; reading the
// substrate lands it one step up wherever it opens, with no prop passed down.
// ---------------------------------------------------------------------------

// No provider means the page itself.
const SurfaceContext = createContext(1);

/** The current substrate level, 1 when no provider is present. */
export function useSurface() {
  return useContext(SurfaceContext);
}

export function SurfaceProvider({ value, children }) {
  // Clamped to the ladder: a deep stack keeps resolving to a real surface
  // token instead of a level with no background or shadow defined.
  return (
    <SurfaceContext.Provider value={Math.max(1, Math.min(8, value))}>
      {children}
    </SurfaceContext.Provider>
  );
}
